// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 4d).
// Tab "Ubicaciones / Sedes" — 1:1 move del JSX. Muestra el listado de
// sedes del cliente y el diálogo de creación. El estado del formulario,
// los handlers y el modal de edición viven en el padre y se reciben como
// props para no cambiar la funcionalidad ni el estilo.
import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Badge } from "../ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Plus, MapPin, Edit2, Trash2 } from "lucide-react";

export const UbicacionesTab = ({
  locations,
  locationModalOpen,
  setLocationModalOpen,
  newLocation,
  setNewLocation,
  handleCreateLocation,
  openEditLocation,
  setDeleteConfirm,
  formatDateTime,
}) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-heading font-semibold text-white">
          Ubicaciones / Sedes
        </h3>
        <Dialog open={locationModalOpen} onOpenChange={setLocationModalOpen}>
          <DialogTrigger asChild>
            <Button className="bg-[#42E695] text-[#04042C] hover:bg-[#34D399]">
              <Plus className="h-4 w-4 mr-2" />
              Nueva Ubicación
            </Button>
          </DialogTrigger>
          <DialogContent
            className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-lg"
            onPointerDownOutside={(e) => e.preventDefault()}
          >
            <DialogHeader>
              <DialogTitle className="text-white font-heading">
                Nueva Ubicación / Sede
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-4 mt-4">
              <div>
                <Label className="text-slate-300">Nombre Sede *</Label>
                <Input
                  value={newLocation.nombre_sede}
                  onChange={(e) => setNewLocation({ ...newLocation, nombre_sede: e.target.value })}
                  placeholder="Ej: Oficina Principal, CPD Norte..."
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div>
                <Label className="text-slate-300">Dirección Completa *</Label>
                <Input
                  value={newLocation.direccion_completa}
                  onChange={(e) => setNewLocation({ ...newLocation, direccion_completa: e.target.value })}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-slate-300">Código Postal</Label>
                  <Input
                    value={newLocation.codigo_postal}
                    onChange={(e) => setNewLocation({ ...newLocation, codigo_postal: e.target.value })}
                    className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                  />
                </div>
                <div>
                  <Label className="text-slate-300">Ciudad</Label>
                  <Input
                    value={newLocation.ciudad}
                    onChange={(e) => setNewLocation({ ...newLocation, ciudad: e.target.value })}
                    className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                  />
                </div>
              </div>
              <div>
                <Label className="text-slate-300">Contacto Técnico Sede</Label>
                <Input
                  value={newLocation.contacto_tecnico_sede}
                  onChange={(e) => setNewLocation({ ...newLocation, contacto_tecnico_sede: e.target.value })}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div>
                <Label className="text-slate-300">Teléfono Sede</Label>
                <Input
                  value={newLocation.telefono_sede}
                  onChange={(e) => setNewLocation({ ...newLocation, telefono_sede: e.target.value })}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div>
                <Label className="text-slate-300">Información Adicional</Label>
                <Textarea
                  value={newLocation.informacion_adicional}
                  onChange={(e) => setNewLocation({ ...newLocation, informacion_adicional: e.target.value })}
                  rows={3}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div className="flex justify-end gap-3 pt-4">
                <Button
                  variant="outline"
                  onClick={() => setLocationModalOpen(false)}
                  className="border-[#1E1E5F] text-slate-300"
                >
                  Cancelar
                </Button>
                <Button onClick={handleCreateLocation} className="bg-[#42E695] text-[#04042C]">
                  Crear Ubicación
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          {locations.length === 0 ? (
            <div className="text-center py-8">
              <MapPin className="h-12 w-12 text-slate-500 mx-auto mb-4" />
              <p className="text-slate-400">No hay ubicaciones registradas</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="border-[#1E1E5F]">
                    <TableHead className="text-slate-400">Nombre sede</TableHead>
                    <TableHead className="text-slate-400">Dirección completa</TableHead>
                    <TableHead className="text-slate-400">Código Postal</TableHead>
                    <TableHead className="text-slate-400">Ciudad</TableHead>
                    <TableHead className="text-slate-400">Contacto Técnico</TableHead>
                    <TableHead className="text-slate-400">Servicios</TableHead>
                    <TableHead className="text-slate-400">Creado el</TableHead>
                    <TableHead className="text-slate-400">Acciones</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {locations.map((location) => (
                    <TableRow
                      key={location.id}
                      className="border-[#1E1E5F] hover:bg-[#1B1B4B]/50"
                    >
                      <TableCell className="text-white font-medium">{location.nombre_sede}</TableCell>
                      <TableCell className="text-slate-300">{location.direccion_completa}</TableCell>
                      <TableCell className="text-slate-300">{location.codigo_postal || "-"}</TableCell>
                      <TableCell className="text-slate-300">{location.ciudad || "-"}</TableCell>
                      <TableCell className="text-slate-300">{location.contacto_tecnico_sede || "-"}</TableCell>
                      <TableCell>
                        <Badge className="bg-[#03BEE4]/20 text-[#03BEE4]">
                          {location.services_count || 0} servicios
                        </Badge>
                      </TableCell>
                      <TableCell className="text-slate-300">{formatDateTime(location.created_at)}</TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => openEditLocation(location)}
                            className="text-[#03BEE4] hover:text-[#03BEE4]/80"
                          >
                            <Edit2 className="h-4 w-4" />
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => setDeleteConfirm({ open: true, type: "location", id: location.id, name: location.nombre_sede || location.direccion_completa || "Ubicación" })}
                            className="text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            data-testid={`delete-location-${location.id}`}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};
